/* eslint-disable import/named */
import { ReactNode } from 'react';
import Popover from '@deprecated-ui/common/Popover';
import { useDispatch, useSelector } from 'react-redux';
import {
  effects as companyEffects,
  selectors as companySelectors,
  STATE_DETAIL,
} from 'lib/entities/company';
import auth from 'utils/auth';
import { selectors as profileSelectors } from 'lib/entities/profile';
import If from 'global/ErrorHandlers/If';
import PopoverContentCompany from './PopoverContentCompany';
import PopoverContentFR from './PopoverContentFR';

interface PopoverCompanyProps {
  children: ReactNode;
  symbol: string;
  [key: string]: any;
}

function PopoverCompany({
  children,
  symbol,
  ...otherProps
}: PopoverCompanyProps) {
  const dispatch = useDispatch();
  const { data: profileData } = useSelector(profileSelectors);
  const { country = 'ID' } = profileData;
  const {
    detail: { data: detailSymbol },
    chart: { popoverData: chartSymbol },
  } = useSelector(companySelectors);

  const currentSymbol = detailSymbol?.[symbol] || {};

  const handleGetChart = () => {
    const params = {
      symbol,
      timeframe: 'today',
      isPopover: true,
    };

    dispatch(companyEffects.getCompanyChart(params));
  };

  const handleEnter = () => {
    if (country === 'ID') {
      dispatch(companyEffects.getCompanyDetail(symbol));
      handleGetChart();
    }
  };

  const handleFollowCompany = () => {
    // @ts-ignore
    const { watchlist_id: watchlistId } = auth.getUserAccess();
    const action = currentSymbol?.followed
      ? companyEffects.postUnfollowCompany
      : companyEffects.postFollowCompany;

    const data = {
      watchlistId,
      companyId: currentSymbol?.id,
      stateToUpdate: STATE_DETAIL,
    };

    dispatch(action(data));
  };

  return (
    <>
      <If condition={country === 'ID'}>
        <Popover
          {...otherProps}
          trigger="hover"
          placement="bottom"
          overlayStyle={{
            minWidth: '400px',
          }}
          // @ts-expect-error
          onMouseEnter={handleEnter}
          content={() => {
            if (currentSymbol?.type_company === 'FR') {
              return (
                <PopoverContentFR
                  symbol={symbol}
                  handleFollowCompany={handleFollowCompany}
                  isFollowed={currentSymbol?.followed}
                />
              );
            }
            return (
              <PopoverContentCompany
                chart={chartSymbol[symbol]}
                currentSymbol={currentSymbol}
                handleFollowCompany={handleFollowCompany}
                symbol={symbol}
              />
            );
          }}
        >
          {children}
        </Popover>
      </If>
      <If condition={country === 'MY'}>{children}</If>
    </>
  );
}

export default PopoverCompany;
